import React from "react";
import { inject, observer } from "mobx-react";

import { runInAction } from "mobx";

import MultiSelectWithDoDOrdering from "../../general/MultiSelectWithDoDOrdering";
import { Label } from "react-bootstrap";
import { MultiSearchVariableListItem } from "./MultiSearchVariableListItem";

import "./MultiSearchForm.scss";
import { MULTISEARCH_USAGE } from "src/stores/MultiSearchStore/MultiSearchStore";
import EnvironmentUtils from "src/utils/EnvironmentUtils";

/**
 * @typedef {import("../../stores/MultiSearchStore/MultiSearchFormStore").MultiSearchFormStore} MultiSearchFormStore
 */

@inject("multiSearchStore")
@observer
export class MultiSearchForm extends React.Component {
  state = {
    combinationsOpen: true,
    cubesOpen: true,
  };

  toggleCombinationsOpen = () => {
    this.setState((prevState) => ({
      ...prevState,
      combinationsOpen: !prevState.combinationsOpen,
    }));
  };

  toggleCubesOpen = () => {
    this.setState((prevState) => ({
      ...prevState,
      cubesOpen: !prevState.cubesOpen,
    }));
  };

  render() {
    /**
     * @type MultiSearchFormStore
     */
    const store = this.props.store;
    const { usage } = this.props;

    return (
      <div className="MultiSearchForm">
        {usage === MULTISEARCH_USAGE.ADVANCED_SEARCH ? (
          <MultiSelectWithDoDOrdering
            disabled={this.props.disabled}
            options={store.optionsForSelector}
            order={store.filtersOrder}
            values={store.filtersOrder}
            placeholder={"Select variables..."}
            allowSelectMultipleTimes={false}
            onChangeOrder={store.changeFilterOrder}
            onAdd={store.addFilterItem}
            onDelete={store.deleteFilterItem}
            hideDefaultSelect={true}
          >
            {this.renderInnerComponent()}
          </MultiSelectWithDoDOrdering>
        ) : (
          this.renderInnerComponent()
        )}
      </div>
    );
  }

  renderInnerComponent = () => {
    const store = this.props.store;
    const { usage } = this.props;

    return store.filtersOrder.map((tid) => {
      const allowedFilterState = store.filtersState[tid];
      const allowedFilter = store.allowedFiltersMap[tid];

      let mustMatch =
        usage === MULTISEARCH_USAGE.ADVANCED_SEARCH
          ? allowedFilterState.variable.properties?.MUST_MATCH
          : allowedFilterState.variable.properties?.get("MUST_MATCH") ?? false;

      return (
        <div key={tid} id={tid} className="MultiSearchPage__filter-row item">
          <div
            className={"variable-action"}
            aria-hidden="true"
            onClick={() => store.deleteFilterItem(tid)}
          >
            ×
          </div>
          {!EnvironmentUtils.isBirdApp() && (
            <div
              className="variable-action"
              style={{
                left: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <input
                type="checkbox"
                style={{
                  marginRight: "5px",
                  marginBottom: "5px",
                  transform: "scale(1.2)",
                }}
                checked={mustMatch}
                onChange={() => {
                  runInAction(() => {
                    if (
                      !(
                        allowedFilterState.variable.properties instanceof Map
                      ) &&
                      usage !== MULTISEARCH_USAGE.ADVANCED_SEARCH
                    ) {
                      allowedFilterState.variable.properties = new Map();
                    }
                    usage === MULTISEARCH_USAGE.ADVANCED_SEARCH
                      ? (allowedFilterState.variable.properties["MUST_MATCH"] =
                          !mustMatch)
                      : allowedFilterState.variable.properties.set(
                          "MUST_MATCH",
                          !mustMatch
                        );
                  });
                  store.query();
                }}
              />
              <Label
                style={{
                  color: "white",
                  backgroundColor: mustMatch ? "green" : "grey",
                }}
                onClick={() => {
                  runInAction(() => {
                    if (
                      !(
                        allowedFilterState.variable.properties instanceof Map
                      ) &&
                      usage !== MULTISEARCH_USAGE.ADVANCED_SEARCH
                    ) {
                      allowedFilterState.variable.properties = new Map();
                    }
                    usage === MULTISEARCH_USAGE.ADVANCED_SEARCH
                      ? (allowedFilterState.variable.properties["MUST_MATCH"] =
                          !mustMatch)
                      : allowedFilterState.variable.properties.set(
                          "MUST_MATCH",
                          !mustMatch
                        );
                  });
                  store.query();
                }}
              >
                Must match
              </Label>
            </div>
          )}
          <MultiSearchVariableListItem
            variableTid={tid}
            label={`${allowedFilter?.variable?.name} (${allowedFilter?.variable?.code})`}
            enumeratedItems={allowedFilter?.options}
            values={store.filtersState[tid].options}
            onUpdateEnumeratedList={store.updateFilterOptions}
            usage={usage}
            executeQueryCallback={store.query}
          />
        </div>
      );
    });
  };
}
